import { Component, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { NgbModal, NgbModalOptions } from '@ng-bootstrap/ng-bootstrap';
import { UserIdleService } from 'angular-user-idle';
import { Base64 } from 'js-base64';
import { applicationConstants } from 'src/app/constants';
import { I18nService } from 'src/app/service/i18n.service';
import { environment } from 'src/environments/environment';
import { TranslateService } from '@ngx-translate/core';
import * as CONSTANTS from '../../constants';
import { UtilService } from 'src/app/service/util.service';
import { Subscribable, Subscription } from 'rxjs';
import { maModel } from 'src/app/model/pre-qual-data.model';
declare var $: any;
@Component({
  selector: 'custom-header',
  templateUrl: './custom-header.component.html',
  styleUrls: ['./custom-header.component.less']
})
export class CustomHeaderComponent implements OnInit,OnDestroy {
  contactUsNumber = applicationConstants.contactUsNumber;
  currentLang: string;
  closeResult: string;
  issessionExpired: boolean;
  didTimerStart: boolean;
  cibcWebsiteLink: string = "";
  timeoutCount: number = 0;
  isIos: boolean;
  isSwitch: boolean;
  currentRoutePath: string = '';
  referralFlow: any;
  productFlow: string;
  flowType: any;
  currLangEn = 'en';
  currLangFr = 'fr';
  prequalType = 'P';
  switchType = 'S';
  referral: boolean=false;
  unSubMaAssigned:Subscription;
  maObjPresent: boolean = false;
  isReferralMaPresent: boolean = false;


  referralLink: string;
  maObj: maModel;

  constructor(private translate: TranslateService,
    private i18nService: I18nService, private _activatedRoute: ActivatedRoute,
    private _router: Router, private modalService: NgbModal, private userIdle: UserIdleService, private utilObj: UtilService) {
    this._activatedRoute.url.subscribe(route => {
      this.currentRoutePath = route[0].path;
    });
    this.assignFlowType();
     this._activatedRoute.queryParams.subscribe(params => {
      if (this.utilObj.getReferral(params)) {
        this.referral = true;
      }
      else {
        this.referral = false;
      }
    });
  }

  @ViewChild('modalSession1') content: any;

  ngOnInit(): void {
    this.unSubMaAssigned = this.utilObj.IS_MA_ASSIGNED.subscribe((retObj) => {
      //call will only happen cibc-customer-relationship page
      if (retObj.setObj) {
        this.maObjPresent = true;
        if (retObj.maModelObj != null) {
          this.maObj = retObj.maModelObj;
          this.isReferralMaPresent = true;
        }
        let sessionRefLinkObj = { maObjPresent: this.maObjPresent, isReferralMaPresent: this.isReferralMaPresent, maObj: this.maObj };
        this.utilObj.setsessionStorageGeneric('maReferralLink', sessionRefLinkObj);
      }
     
    })
    this.isSwitch = false;
    this.isIos = !!navigator.platform && /iPad|iPhone|iPod/.test(navigator.platform);
    this.userIdle.startWatching();
    this.issessionExpired = true;

    sessionStorage.setItem("redTm", Base64.encode(String(new Date())));

    this.translate.get('header.cibcWebsiteLink').subscribe((res: string) => {
      this.cibcWebsiteLink = res || "";

    })
   
    this.translate.get('popupMessages.referralURL').subscribe((res: string) => {
      this.referralLink = res || "";
    })

    /** code for session timeout */
    this.userIdle.startWatching();
    this.currentLang = this.i18nService.getCurrentLang();
    this.checkSessionTime();
    this.userIdle.onTimerStart().subscribe(count => {
      if (count == 1 || this.issessionExpired) {
        var digitalData = {
          "events": {
            "siteInteraction": true
          },
          "interaction": {
            "name": "cibc:mortgage-prequalification:session-extend-overlay:initial-warning"
          },
          "errors": [{
            "code": null,
            "field": null,
            "type": null,
            "subtype": null
          }
          ]

        };
        var digitalDataStr = JSON.stringify(digitalData)
        if (document.getElementById("adobe-tracking-digital-data")) {
          document.getElementById("adobe-tracking-digital-data").remove();
          let element = "<script id='adobe-tracking-digital-data' type=\"text/javascript\">var digitalData =" + digitalDataStr + "; if(_satellite){ _satellite.track('track'); }</script>"
          $("head").append(element);
        }
        this.issessionExpired = false;
        this.openWindowCustomClass(this.content);
        this.didTimerStart = true;
      }
    }
    )
    this.userIdle.onTimeout().subscribe(count => {
      this.userIdle.stopTimer();
      this.userIdle.stopWatching();
      this.issessionExpired = false;
      this.timeoutCount = this.timeoutCount + 1;
      this.openWindowCustomClass(this.content);
      this.currentLang = sessionStorage.getItem("lang_ref");
      sessionStorage.clear();
      sessionStorage.setItem("lang_ref", this.currentLang);
      sessionStorage.setItem("redTm", Base64.encode(String(new Date())));
      sessionStorage.setItem("currLang", this.currentLang);
      sessionStorage.setItem('manageSession', "true");
      sessionStorage.setItem("isSessionExpired", "true");
      this.issessionExpired = true;
      var digitalData = {
        "events": {
          "siteInteraction": true
        },
        "interaction": {
          "name": "cibc:mortgage-prequalification:session-extend-overlay:final-warning"
        }

      };
      var digitalDataStr = JSON.stringify(digitalData)

      if (document.getElementById("adobe-tracking-digital-data")) {
        document.getElementById("adobe-tracking-digital-data").remove();
        let element = "<script id='adobe-tracking-digital-data' type=\"text/javascript\">var digitalData =" + digitalDataStr + "; if(_satellite){ _satellite.track('track'); }</script>"
        $("head").append(element);
      }

    })
    let checkType = JSON.parse(sessionStorage.getItem('flow_type'));
    if (checkType && checkType?.type === 'switch') {
      this.isSwitch = true;
    }
    this.checkForMaObjPrsInSession();
  }
  checkForMaObjPrsInSession() {
    let maDetail: any = this.utilObj.getSessionStorageGeneric('maReferralLink');
    if (maDetail != undefined) {
      this.maObjPresent = maDetail.maObjPresent;
      this.isReferralMaPresent = maDetail.isReferralMaPresent;
      this.maObj = maDetail.maObj;
    }
  }
  assignFlowType() {
    this._activatedRoute.queryParams.subscribe(params => {
      this.flowType = this.utilObj.getFlowType(params);
    })
  }
  openWindowCustomClass(content) {
    if (this.timeoutCount == 0) {
      this.utilObj.CLOSE_WINDOW_POPUP.next(false);
      this.modalService.open(content, { ariaLabelledBy: 'modal-basic-title', size: 'md', backdrop: 'static', windowClass: 'session-timeout-modal' }).result.then((result) => {
        this.closeResult = `Closed with: ${result}`;
      }, (reason) => {
      });
    }
  }
  redirectToCibc() {
    window.open("https://www.cibc.com/" + sessionStorage.getItem("currLang") + "/personal-banking.html", "_self");
  }

  changeLanguage(lang: string) {
    this.i18nService.setCurrenttLang(lang);
    this.currentLang = this.i18nService.getCurrentLang();
  }

  clearSession() {
    let currLang = sessionStorage.getItem("currLang");
    this.utilObj.isSidebarVisible.next(true);
    this.utilObj.isSummaryPage.next(false);
    sessionStorage.clear();
    sessionStorage.setItem("lang_ref", currLang);
    sessionStorage.setItem("redTm", Base64.encode(String(new Date())));
    sessionStorage.setItem("currLang", currLang);
    sessionStorage.setItem('manageSession', "true");

    this.userIdle.resetTimer();
    this.modalService.dismissAll();
    this.userIdle.startWatching();
    this.issessionExpired = true;
    this.timeoutCount = 0;
    this.assignFlowType();
    sessionStorage.setItem('manageSession', "true");
    this._router.navigate(['../home'], { relativeTo: this._activatedRoute, queryParamsHandling: 'preserve' });
  }


  checkSessionTime() {
    let date = new Date(Base64.decode(sessionStorage.getItem("redTm")));
    if (date) {
      if (date.getDate() == new Date().getDate()) {
        let redTime = date.getTime();
        let currTime = new Date().getTime();
        let timeonCibcPortal = currTime - redTime;
        if (Number(timeonCibcPortal) > CONSTANTS.sessionConstants.MAXIDELTIME) {

          sessionStorage.setItem('manageSession', "true");
          this._router.navigate(['../home'], { relativeTo: this._activatedRoute, queryParamsHandling: 'preserve' })
            .then(() => {
            });
        }
      }
    }
  }


  resetTimer() {
    this.userIdle.resetTimer();
    this.userIdle.startWatching();
    this.modalService.dismissAll();
    this.issessionExpired = true;
    if (this.isIos) {
      //document.getElementById("logoId").blur();
      window.location.reload();
    }

    /* setTimeout(function(){ 
       document.getElementById("logoId").focus();
       document.getElementById("logoId_mobile").focus();
       
     },0)*/
  }


  dismissModal() {

    this.modalService.dismissAll();
    this.userIdle.stopTimer();
    this.currentLang = sessionStorage.getItem("lang_ref");
    sessionStorage.clear();
    sessionStorage.setItem("lang_ref", this.currentLang);
    sessionStorage.setItem("redTm", Base64.encode(String(new Date())));
    sessionStorage.setItem("currLang", this.currentLang);
    sessionStorage.setItem('manageSession', "true");
    this.issessionExpired = true;
    var digitalData = {
      "events": {
        "siteInteraction": true
      },
      "interaction": {
        "name": "cibc:mortgage-prequalification:assistance:call-us"
      }

    };

    var digitalDataStr = JSON.stringify(digitalData)

    if (document.getElementById("adobe-tracking-digital-data")) {
      document.getElementById("adobe-tracking-digital-data").remove();
      let element = "<script id='adobe-tracking-digital-data' type=\"text/javascript\">var digitalData =" + digitalDataStr + "; if(_satellite){ _satellite.track('track'); }</script>"
      $("head").append(element);
    }
    if (this.currentLang == "en") {
      window.location.href = environment.api.mortgageHome_en;
    } else {
      window.location.href = environment.api.mortgageHome_fr;
    }
  }
  openContactPopup() {
    $("#referralPopup").modal("show")
  }
  ngOnDestroy() {
    if (this.unSubMaAssigned != undefined) {
      this.unSubMaAssigned.unsubscribe();
    }
  }
  closePopup() {
    $("#referralPopup").modal("hide");
    document.getElementById('contactus')?.focus();
  }
  closeGeneric() {
    this.utilObj.CLOSE_WINDOW_POPUP.next(false);
  }
  findAdvisor() {
    window.location.href = this.referralLink;
  }

}
